
import { Injectable } from "@angular/core";
import { RockService } from '../rock.service';
import { RockBulkExportAttributesExport, RockBulkExportLocationExport, RockBulkExportPeopleExport, RockBulkExportPersonExport, RockFieldConfigurationValue, RockModelBinaryFile, RockModelBinaryFileType, RockModelCategory, RockModelDefinedValue, RockModelDocument, RockModelDocumentType, RockModelEntityType, RockModelPerson, RockModelPhoneNumber, RockModelUserLogin, RockRestControllersConfigureTextToGiveArgs, RockRestControllersPeopleControllerDuplicatePersonInfo, RockRestControllersPersonInteractionStatistics, RockRestControllersPersonSearchPhoneNumber, RockRestControllersPersonSearchResult, RockWebCacheAttributeCache, RockWebCacheAttributeValueCache} from './People.models';

@Injectable()
export class PeopleService extends RockService {

override entityType = 'People';

    GetPeople(filter?: any) {
        return this.get(`People${filter}`);
    }

    PostPeople(person: RockModelPerson) {
        return this.post(`People`, person);
    }

    GetPeopleBykey(key: string) {
        return this.get(`People(${key})`);
    }

    GetPeopleByid(id: number) {
        return this.get(`People/${id}`);
    }

    PutPeopleByid(id: number, value: RockModelPerson) {
        return this.put(`People/${id}`, value);
    }

    DeletePeopleByid(id: number) {
        return this.delete(`People/${id}`);
    }

    PatchPeopleByid(id: number, values: object) {
        return this.patch(`People/${id}`, values);
    }

    PostPeopleAddExistingPersonToFamily() {
        return this.post(`People/AddExistingPersonToFamily`);
    }

    PostPeopleAddNewPersonToFamilyByfamilyId(familyId: number, person: RockModelPerson) {
        return this.post(`People/AddNewPersonToFamily/${familyId}`, person);
    }

    PostPeopleAttributeValueByid(id: number, attributeKey: string, attributeValue: string) {
        return this.post(`People/AttributeValue/${id}?attributeKey=${attributeKey}&attributeValue=${attributeValue}`);
    }

    DeletePeopleAttributeValueByid(id: number) {
        return this.delete(`People/AttributeValue/${id}`);
    }

    PostPeopleConfigureTextToGiveBypersonId(personId: number, args: RockRestControllersConfigureTextToGiveArgs) {
        return this.post(`People/ConfigureTextToGive/${personId}`, args);
    }

    GetPeopleDataViewByid(id: number) {
        return this.get(`People/DataView/${id}`);
    }

    GetPeopleExport() {
        return this.get(`People/Export`);
    }

    GetPeopleFollowedItems() {
        return this.get(`People/FollowedItems`);
    }

    GetPeopleGetByAttributeValue() {
        return this.get(`People/GetByAttributeValue`);
    }

    GetPeopleGetByEmail() {
        return this.get(`People/GetByEmail`);
    }

    GetPeopleGetByEmailByemail(email: string) {
        return this.get(`People/GetByEmail/${email}`);
    }

    GetPeopleGetByPersonAliasIdBypersonAliasId(personAliasId: number) {
        return this.get(`People/GetByPersonAliasId/${personAliasId}`);
    }

    GetPeopleGetByPhoneNumberBynumber(number: string) {
        return this.get(`People/GetByPhoneNumber/${number}`);
    }

    GetPeopleGetByTokenBytoken(token: string) {
        return this.get(`People/GetByToken/${token}`);
    }

    GetPeopleGetByUserNameByusername(username: string) {
        return this.get(`People/GetByUserName/${username}`);
    }

    GetPeopleGetCurrentPerson() {
        return this.get(`People/GetCurrentPerson`);
    }

    GetPeopleGetCurrentPersonImpersonationToken() {
        return this.get(`People/GetCurrentPersonImpersonationToken`);
    }

    GetPeopleGetGraduationYearBygradeOffset(gradeOffset: number) {
        return this.get(`People/GetGraduationYear/${gradeOffset}`);
    }

    GetPeopleGetImpersonationParameter() {
        return this.get(`People/GetImpersonationParameter`);
    }

    GetPeopleGetInteractionStatisticsBypersonId(personId: number) {
        return this.get(`People/GetInteractionStatistics/${personId}`);
    }

    GetPeopleGetPotentialDuplicates() {
        return this.get(`People/GetPotentialDuplicates`);
    }

    GetPeopleGetSearchDetails() {
        return this.get(`People/GetSearchDetails`);
    }

    GetPeopleInDataViewBydataViewIdByentityId(dataViewId: number, entityId: number) {
        return this.get(`People/InDataView/${dataViewId}/${entityId}`);
    }

    PostPeopleLaunchWorkflowByid(id: number, workflowAttributeValues: object) {
        return this.post(`People/LaunchWorkflow/${id}`, workflowAttributeValues);
    }

    PostPeopleOneClickUnsubscribeBypersonActionIdentifier(personActionIdentifier: string) {
        return this.post(`People/OneClickUnsubscribe/${personActionIdentifier}`);
    }

    GetPeoplePopupHtmlBypersonId(personId: number) {
        return this.get(`People/PopupHtml/${personId}`);
    }

    GetPeoplePopupHtmlBypersonIdByemailAsLink(personId: number, emailAsLink: boolean) {
        return this.get(`People/PopupHtml/${personId}/${emailAsLink}`);
    }

    GetPeopleSearch() {
        return this.get(`People/Search`);
    }

    PutPeopleSetContextByid(id: number) {
        return this.put(`People/SetContext/${id}`);
    }

    OptionsPeopleSetContextByid(id: number) {
        return this.options(`People/SetContext/${id}`);
    }

    PostPeopleUpdatePersonProfilePhoto(photoBytes: string) {
        return this.post(`People/UpdatePersonProfilePhoto`, photoBytes);
    }

    PostPeopleUpdateProfilePhoto(photoBytes: string) {
        return this.post(`People/UpdateProfilePhoto`, photoBytes);
    }

    GetPeopleVCardBypersonGuid(personGuid: string) {
        return this.get(`People/VCard/${personGuid}`);
    }

}